import React, { useContext } from 'react';

import { connectRefinementList } from 'react-instantsearch-dom';

import { DiscoverContext } from '../../../../context/DiscoverContext';
import { Tabs } from '../Tabs';

const ControlledTabs = ({ attribute, withLinks = false, refine }) => {
  const { searchState } = useContext(DiscoverContext);

  const refinement =
    searchState?.refinementList && searchState?.refinementList[attribute]
      ? searchState?.refinementList[attribute]
      : null;
  const selectedItem = refinement ? (Array.isArray(refinement) ? refinement[0] : refinement) : '';

  return <Tabs selectedItem={selectedItem} refine={withLinks ? undefined : refine} />;
};

export default connectRefinementList(ControlledTabs);
